import { InspectionModel } from 'shared/domain/inspection/inspectionModel';
import { areObjectIdsEqual } from 'helpers/idComparison';
import {
  areProtocolIssueIdsEqual,
  mergeProtocolIssueIds,
} from './mergeProtocolIssueIds';

export function mergeProtocolIssuesOnInspectionModel(
  previous: InspectionModel,
  fetched: InspectionModel
): InspectionModel {
  if (!areObjectIdsEqual(previous._id, fetched._id)) {
    return fetched;
  }

  return {
    ...fetched,
    protocol: fetched.protocol.map((fetchedItem) => {
      const previousItem = previous.protocol.find((item) =>
        areObjectIdsEqual(item._id, fetchedItem._id)
      );
      if (!previousItem) {
        return fetchedItem;
      }

      const mergedIssues = mergeProtocolIssueIds(
        previousItem.complianceCheck.issues ?? [],
        fetchedItem.complianceCheck.issues ?? []
      );

      if (
        areProtocolIssueIdsEqual(
          mergedIssues,
          fetchedItem.complianceCheck.issues ?? []
        )
      ) {
        return fetchedItem;
      }

      return {
        ...fetchedItem,
        complianceCheck: {
          ...fetchedItem.complianceCheck,
          issues: mergedIssues,
        },
      };
    }),
  };
}
